/// <reference path="../../app.definition.ts" />

angular.module('eCareVault.common.factory')
        .factory('hsq', ['$window',($window: ng.IWindowService): any[] => $window._hsq || window._hsq || []]);

